const GRAD_TO_RAD_RATIO = Math.PI / 180;

export const degreesToRadians = (grad: number) => {
  return grad * GRAD_TO_RAD_RATIO;
};
